import * as React from "react";
import { useSelector } from "react-redux";
import CmsComponent from "../../cmsComponent";
import Wrapper from "../Summary/wrapper";
var GenericContent = function GenericContent() {
    var _React$useState = React.useState(true), setIsScrollToBottom = _React$useState[1];
    var activePlanLevel = useSelector(function (state) { return state.ui.cmsComponentId; });
    var innerRef = React.useRef(null);
    var handleScroll = function handleScroll() { if (innerRef.current) {
        var _innerRef$current = innerRef.current, scrollTop = _innerRef$current.scrollTop, scrollHeight = _innerRef$current.scrollHeight, clientHeight = _innerRef$current.clientHeight;
        if (Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1) {
            setIsScrollToBottom(false);
        }
    } };
    React.useEffect(function () { handleScroll(); }, []);
    return /*#__PURE__*/ React.createElement("div", { className: "m-auto lg:max-w-2xl lg:w-full justify-center lg:flex" }, /*#__PURE__*/ React.createElement("div", { className: "bg-popup-1 rounded-2xl max-w-3xl text-left p-7" }, /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement("div", { className: "overflow-y-auto h-fit" // style={{ height: "80vh", overflow: "auto" }}
        ,
        onScroll: handleScroll, ref: innerRef }, /*#__PURE__*/ React.createElement(CmsComponent, { pdfButton: true, componentId: activePlanLevel })))));
};
export default GenericContent;
